import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropzone"]
  static classes = ["active"]

  connect() {
    this.dropzoneTarget.addEventListener("dragenter", this.handleDragEnter.bind(this))
    this.dropzoneTarget.addEventListener("dragover", this.handleDragOver.bind(this))
    this.dropzoneTarget.addEventListener("dragleave", this.handleDragLeave.bind(this))
  }

  handleDragEnter(event) {
    event.preventDefault()
    this.highlight()
  }

  handleDragOver(event) {
    event.preventDefault()
    this.highlight()
  }

  handleDragLeave(event) {
    event.preventDefault()
    this.unhighlight()
  }

  drop(event) {
    event.preventDefault()
    this.unhighlight()

    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  highlight() {
    this.dropzoneTarget.classList.add(...this.activeClasses)
  }

  unhighlight() {
    this.dropzoneTarget.classList.remove(...this.activeClasses)
  }
}
